import initTestimonials from './components/testimonials';
import initShowcase from './components/showcase';

const testimonials = document.querySelector('.js-testimonials');

if (testimonials) {
    initTestimonials(testimonials);
}

const showcase = document.querySelector('.js-showcase');

if (showcase) {
    initShowcase(showcase);
}
